import React from "react";
import styled from "styled-components";
import { navigate } from "gatsby-plugin-intl";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import get from "lodash/get";

const StyledWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  padding-left: 0.8rem;
  align-items: center;
  height: 100%;
  z-index: 2;
  background-color: ${(props) => props.theme.color.cream};
  ${(props) => props.theme.responsive.desktop} {
    padding-left: 0.5rem;
  }
`;

const StyledButtonWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.4rem;
  border-right: 1px solid ${(props) => props.theme.color.grey};
  opacity: ${(props) => (props.isSelected ? 1 : 0.6)};
  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }
  ${(props) => props.theme.responsive.desktop} {
    padding: 0 0.6rem;
  }
`;

const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 100%;
  padding: 0.2rem 0;
  background-color: ${(props) => props.theme.color.cream};
  ${(props) => props.theme.responsive.desktop} {
    padding: 0.4rem 0;
  }
  & > div {
    height: 100%;
    margin: 0.2rem 0;
  }
`;

const CollectionLogo = ({ location, title, img, link }) => {
  const handleNavigateTo = (link) => {
    navigate(link);
  };
  return (
    <StyledButtonWrapper
      isSelected={location === link}
      onClick={() => handleNavigateTo(link)}
    >
      <StyledLogo>
        <GatsbyImage
          image={getImage(img)}
          imgStyle={{
            objectFit: "contain",
            objectPosition: "center",
          }}
          alt={title}
        />
      </StyledLogo>
    </StyledButtonWrapper>
  );
};

export default function CollectionNav({ location, ...props }) {
  const { pdLogo, zLogo } = useStaticQuery(graphql`
    {
      pdLogo: file(relativePath: { eq: "PD/pd10Icon.png" }) {
        childImageSharp {
          gatsbyImageData(
            formats: [AUTO, WEBP, AVIF]
            width: 80
            placeholder: BLURRED
          )
        }
      }
      zLogo: file(relativePath: { eq: "Logo/visionZIcon.png" }) {
        childImageSharp {
          gatsbyImageData(
            formats: [AUTO, WEBP, AVIF]
            width: 80
            placeholder: BLURRED
          )
        }
      }
    }
  `);
  return (
    <StyledWrapper>
      <CollectionLogo
        title="pd"
        location={get(location, "pathname", "") + get(location, "search", "")}
        img={pdLogo}
        link="/collection/pd10"
      />
    </StyledWrapper>
  );
}
